import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { Point } from 'geojson';
import { MapElement } from '~app/shared/map/map-element.model';
import { AuthService } from '~app/auth/auth.service';
import { V2LService } from '~app/v2l/v2l.service';
import { Tv2l } from '../v2l.type';

@Component({
  selector: 'qm-v2l-hover',
  templateUrl: './v2l-hover.component.html'
})
export class V2LHoverComponent implements OnInit {
  @Input()
  public selectedFeature: MapElement<Point>;
  public analysis: Tv2l[];
  private selectedPoint: Point;

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly http: HttpClient,
    private readonly auth: AuthService,
    private readonly v2lService: V2LService,
  ) {}

  ngOnInit() {}

  async ngOnChanges(changes: SimpleChanges) {
    await this.fetch();
  }

  /**
   * determine accurate coordinates as "Point" and fetch analysis for that "Point"
   */
  private async fetch() {
    this.selectedPoint = await this.v2lService.getHasAnalysis(this.selectedFeature);
    this.analysis = (await this.v2lService.getLatestAnalysisForCoordinates(this.selectedPoint))?.data;
    //// inject also default properties if correctly set in ingested data
    if (this.analysis[0]?.NaytteenottoMatka.Naytteenotto.NaytteenottoPaikka.properties['nimi']) {
      this.selectedFeature.properties['NaytteenottoMatka.Naytteenotto.NaytteenottoPaikka.properties.nimi'] = this.analysis[0]?.NaytteenottoMatka.Naytteenotto.NaytteenottoPaikka.properties['nimi'];
      this.selectedFeature.properties['NaytteenottoMatka.Naytteenotto.Nayte.Analyysitulos.MaaritysmenetelmaNimi'] = this.analysis[0]?.NaytteenottoMatka.Naytteenotto.Nayte.Analyysitulos[0].MaaritysmenetelmaNimi;
    }
    this.cdr.markForCheck();
  }
}
